// Centralized configuration.
// - baseURL: "http(s)://host:port"
// - wsURL: "ws(s)://host:port"
export const createConfig = ({
  baseURL = window.location.protocol === 'https:' ? "https://localhost:8080" : "http://localhost:8080",
  wsURL = window.location.protocol === 'https:' ? "wss://localhost:8080" : "ws://localhost:8080",
  // optional: attach credentials, headers, etc.
  defaultHeaders = { "Content-Type": "application/json" },
} = {}) => ({
  baseURL: baseURL.replace(/\/+$/, ""),
  wsURL: wsURL.replace(/\/+$/, ""),
  defaultHeaders,
});
